/**
 * Unified KYC document type constants.
 *
 * All keys match the backend Java enums exactly.
 * Both CAF form fields and UserKYC upload dialogs now use the SAME keys.
 *
 * Backend enums:
 *   - IdentityProofType.java  → used by CafEntity.identityProofType
 *   - AddressProofType.java   → used by CafEntity.addressProofType
 *   - DocumentType.java       → used by KycDocumentEntity.documentType
 *                               (canonical keys added to align with above)
 */

// ─── ID Proof types (same keys for CAF identityProofType AND UserKYC upload) ──
export const ID_PROOF_TYPES = [
  { key: "AADHAAR", label: "Aadhaar" },
  { key: "VOTER_ID", label: "Voter Id" },
  { key: "PASSPORT", label: "Passport" },
  { key: "DRIVING_LICENSE", label: "Driving License" },
  { key: "PAN", label: "Pan Card" },
  { key: "GOVT_EMPLOYEE_ID", label: "Government Employee Id" },
  { key: "BANK_PASSBOOK", label: "Bank Passbook" },
  { key: "PSU_ID", label: "PSU Id" },
  { key: "DEFENCE_ID", label: "Defence ID" },
  { key: "PENSION_CARD", label: "Pension Card" },
];

// ─── Address Proof types (same keys for CAF addressProofType AND UserKYC upload) ─
export const ADDRESS_PROOF_TYPES = [
  { key: "AADHAAR", label: "Aadhaar" },
  { key: "VOTER_ID", label: "Voter Id" },
  { key: "PASSPORT", label: "Passport" },
  { key: "DRIVING_LICENSE", label: "Driving License" },
  { key: "RATION_CARD", label: "Ration Card" },
  { key: "ELECTRICITY_BILL", label: "Electricity Bill" },
  { key: "TELEPHONE_BILL", label: "Telephone Bill" },
  { key: "GAS_BILL", label: "Gas Bill" },
  { key: "BANK_PASSBOOK", label: "Bank Passbook" },
  { key: "RENT_AGREEMENT", label: "Rent Agreement" },
  { key: "PROPERTY_TAX_RECEIPT", label: "Property Tax Receipt" },
  { key: "WATER_BILL", label: "Water Bill" },
  { key: "GOVT_ID", label: "Government Id" },
  { key: "GST", label: "GST" },
];

// ─── Profile Proof ────────────────────────────────────────────────────────────
export const PROFILE_PROOF_TYPES = [{ key: "PROFILE_PIC", label: "Profile Pic" }];

// ─── CAF Proof ────────────────────────────────────────────────────────────────
export const CAF_PROOF_TYPES = [{ key: "CAF_PROOF", label: "CAF Proof" }];
